import index from "@/pages/company/tag/Index";
import type from "@/pages/company/tag/Type";
import setting from "@/pages/company/tag/Setting";

export default [
    {
        path: 'company-tag',
        name: 'company-tag',
        meta: {
            title: '标签管理'
        },
        redirect : {
            name : "company-tag-type",
        },
        component: index,
        children:[
            {
                path: 'company-tag-type',
                name: 'company-tag-type',
                meta: {
                    title: '标签管理-单位管理'
                },
                component: type,
            },
            {
                path: 'company-tag-options',
                name: 'company-tag-options',
                meta: {
                    title: '标签管理-单位管理'
                },
                component: setting,
            }
        ]
    },

]


// WEBPACK FOOTER //
// ./src/router/company/tag/index.js